import type { OptimizationGoal } from './types';

export const OPTIMIZATION_GOAL_LABEL: Record<OptimizationGoal, string> = {
  PERFORMANCE: 'Performance',
  BALANCED: 'Balanced',
  COST_SAVING: 'Cost saving',
};

export const ALL_OPTIMIZATION_GOALS: OptimizationGoal[] = [
  'PERFORMANCE',
  'BALANCED',
  'COST_SAVING',
];
